import React from "react";
import PropTypes from "prop-types";
import style from "./FloatingButton.module.scss";
import { Menu, MainButton, ChildButton } from "../../FloattingButton";

const FloatingButton = ({ onClick }) => (
  <Menu effect="slidein" method="hover" position="br" className={style.root}>
    <MainButton iconResting="fa fa-plus" iconActive="fa fa-plus" className={style.main} />

    <ChildButton
      style={{ background: "#2cb15a" }}
      icon="fa fa-suitcase"
      label="New Recurring Commission"
      onClick={() => onClick()}
    />
  </Menu>
);

FloatingButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default FloatingButton;
